(() => {
  const observed = new WeakSet();
  const css = `
    /* Give the upgraded runtime a real box instead of a flattened display:contents host. */
    .agent-shell__runtime {
      display: block !important; position: fixed !important; inset: 0 !important;
      width: 100% !important; height: 100% !important; overflow: visible !important;
      pointer-events: none !important;
    }
    /* Keep the native clickable launcher visible through app arrival/nudge states. */
    .activator-nudge {
      opacity: 1 !important; visibility: visible !important;
      scale: 1 !important; translate: none !important;
    }
    button.activator {
      opacity: 1 !important; visibility: visible !important; scale: 1 !important;
       pointer-events: auto !important;
      position: relative !important;
      width: 56px !important; height: 56px !important; min-width: 56px !important;
      padding: 0 !important; border: 0 !important; border-radius: 50% !important;
      background: #fbf8f5 !important; color: #000 !important;
      box-shadow: 0 3px 14px rgba(0,0,0,.13) !important;
      display: flex !important; align-items: center !important; justify-content: center !important;
    }
    button.activator .activator__label, button.activator .activator__icon { display: none !important; }
    button.activator::before {
      content: ''; position: absolute; width: 23px; height: 15px;
      background: #000; border-radius: 8px; left: 50%; top: 50%; transform: translate(-50%,-60%);
    }
    button.activator::after {
      content: ''; position: absolute; width: 7px; height: 7px;
      background: #000; clip-path: polygon(0 0,100% 0,100% 100%);
      left: calc(50% + 3px); top: calc(50% + 4px);
    }
    button.activator:focus-visible { outline: 2px solid #000 !important; outline-offset: 3px !important; }
    @media (max-width: 749px) {
      .activator-nudge {
        position: fixed !important; left: auto !important; top: auto !important;
        right: max(12px, env(safe-area-inset-right)) !important;
        bottom: calc(12px + env(safe-area-inset-bottom) + var(--custom-chat-preview-offset, 0px) + var(--custom-chat-viewport-offset, 0px)) !important;
        margin: 0 !important; transform: none !important;
        
        z-index: 2147483000 !important;
      }
      :host { --shopify-agent-activator-offset: 12px; }
      button.activator { visibility: visible !important; pointer-events: auto !important; width: 50.4px !important; height: 50.4px !important; min-width: 50.4px !important; touch-action: pan-y !important; cursor: pointer !important; transform: none !important;  }
      button.activator::before { width: 19.6px; height: 12.6px; border-radius: 7px; }
      button.activator::after { width: 5.6px; height: 5.6px; top: calc(50% + 3.5px); left: calc(50% + 2.8px); }
    }
  `;
  const scan = (root) => {
    if (!observed.has(root)) {
      observed.add(root);
      new MutationObserver(() => scan(root)).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-expanded']});
    }
    if (root.querySelector('button.activator') && !root.querySelector('[data-custom-round-chat-style]')) {
      const style = document.createElement('style');
      style.dataset.customRoundChatStyle = 'v1';
      style.textContent = css;
      root.append(style);
    }
    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) scan(element.shadowRoot);
    });
  };
  const updatePreviewOffset = () => {
    const viewport = window.visualViewport;
    const visibleBottom = viewport ? Math.min(innerHeight, viewport.offsetTop + viewport.height) : innerHeight;
    // Native fixed positioning follows browser chrome. Only compensate for an
    // on-screen keyboard; toolbar scroll offsets otherwise make the launcher jump.
    const editing = document.activeElement?.matches('input, textarea, [contenteditable="true"]') ||
      document.querySelector('shopify-chat')?.matches(':focus-within');
    const viewportOffset = editing && viewport && viewport.scale === 1 && innerHeight - viewport.height > 150
      ? Math.max(0, innerHeight - visibleBottom) : 0;
    const frame = document.getElementById('PBarNextFrame');
    const rect = frame?.getBoundingClientRect();
    const offset = rect && rect.height > 0 && rect.height < 160 ? Math.max(0, visibleBottom - rect.top) : 0;
    const setOffset = (name, value) => {
      const text = `${value}px`;
      if (document.documentElement.style.getPropertyValue(name) !== text) document.documentElement.style.setProperty(name, text);
    };
    setOffset('--custom-chat-preview-offset', offset);
    setOffset('--custom-chat-viewport-offset', viewportOffset);
  };
  updatePreviewOffset();
  window.addEventListener('resize', updatePreviewOffset, {passive: true});
  window.addEventListener('pageshow', updatePreviewOffset, {passive: true});
  window.visualViewport?.addEventListener('resize', updatePreviewOffset, {passive: true});
  window.visualViewport?.addEventListener('scroll', updatePreviewOffset, {passive: true});
  const previewObserver = new ResizeObserver(updatePreviewOffset);
  const previewTimer = setInterval(() => {
    updatePreviewOffset();
    const frame = document.getElementById('PBarNextFrame');
    if (frame) { previewObserver.observe(frame); clearInterval(previewTimer); }
  }, 500);
  setTimeout(() => clearInterval(previewTimer), 15000);
  scan(document);
  let attempts = 0;
  const timer = setInterval(() => { scan(document); if (++attempts >= 30) clearInterval(timer); }, 500);
})();
